import { Box, Button } from "@mui/material";

import { useTranslation } from "next-i18next";

import { useRouter } from "next/router";

import React, { useEffect } from "react";

import { AlternateLangUrl } from "../../../context/alternateLangContext/context";
import I18nLink from "../I18nLink";

const alternateLanguages = {
    en: {
        language: "English",
        flag: "🇬🇧"
    },
    fr: {
        language: "français",
        flag: "🇫🇷"
    },
    de: {
        language: "Deutsch",
        flag: "🇩🇪"
    },
    "x-default": {
        language: "English",
        flag: "🇬🇧"
    }
};

type Props = {
    languages?: AlternateLangUrl[];
};

const AlternateArticleLanguage = ({ languages }: Props) => {
    const { locale } = useRouter();
    const [userLanguage, setUserLanguage] = React.useState(locale);

    useEffect(() => {
        // Split the locale to get the language code - e.g. en-US => en
        const userLocale = navigator && (navigator.language.split("-")[0] as "en" | "fr");
        setUserLanguage(userLocale);
    }, []);

    const { t } = useTranslation("article", { keyPrefix: "alternativeLanguage" });

    // If the user is browsing using a lang that is not native to the current page then show the alternate languages
    if (userLanguage !== locale) {
        if (languages && languages.length > 0) {
            return (
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "row"
                    }}
                >
                    {languages
                        // remove the current locale as that is the current page
                        .filter((post) => post.hrefLang !== locale)
                        // create links to other posts
                        .map((post) => (
                            <Button
                                variant="outlined"
                                color="secondary"
                                href={post.href}
                                rel="alternate"
                                hrefLang={post.hrefLang}
                                key={post.hrefLang}
                                component={I18nLink}
                                locale={post.hrefLang}
                                startIcon={alternateLanguages[post.hrefLang].flag}
                            >
                                {t(post.hrefLang)}
                            </Button>
                        ))}
                </Box>
            );
        }
        return null;
    }
    return null;
};

export default AlternateArticleLanguage;
